import { createReducer, createActions } from "reduxsauce";
import update from "immutability-helper";
import { IState, ISuccessAction, IFailureAction } from "interfaces/list-duck";
import { GroupPermission } from "interfaces/group";

const { Types, Creators } = createActions(
  {
    request: ["query", "onSuccess"],
    success: ["data"],
    failure: ["error"],
    reset: [],
  },
  { prefix: "LIST_GROUP_PERMISSIONS_" }
);

export interface ListGroupPermissionsState extends IState {
  data: GroupPermission[];
}

interface ISuccessListUnitsAction extends ISuccessAction {
  data: GroupPermission[];
}

const INITIAL_STATE: ListGroupPermissionsState = {
  data: [],
  loading: false,
  error: null,
};

const request = (state: ListGroupPermissionsState) =>
  update(state, {
    loading: { $set: true },
    error: { $set: null },
  });

const success = (state: ListGroupPermissionsState, action: ISuccessListUnitsAction) =>
  update(state, {
    data: { $set: action.data },
    loading: { $set: false },
  });

const failure = (state: ListGroupPermissionsState, action: IFailureAction) =>
  update(state, {
    loading: { $set: false },
    error: { $set: action.error },
  });

const reset = () => INITIAL_STATE;

export const listGroupPermissions = createReducer(INITIAL_STATE, {
  [Types.REQUEST]: request,
  [Types.SUCCESS]: success,
  [Types.FAILURE]: failure,
  [Types.RESET]: reset,
});

export const ListGroupPermissionsTypes = Types;
export const ListGroupPermissionsActions = Creators;
